import * as React from "react";
import {
    Grid,
    IconButton,
    Tooltip
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

export const StyledTooltip = withStyles({
    tooltip: {
        fontSize: "14px",
        backgroundColor: "black"
    }
})(Tooltip);

const Icon = ({
    component: Icon, 
    onClick, 
    selected = false,
    selectable = false,
    disabled = false, 
    title = "", 
    color= "", 
    style = {}
}: any) => {
    let iconStyle = {
        ...style,
        padding: "4px",
        margin: "0 1px"
    }
    if (selectable && selected ) {
        iconStyle = { ...iconStyle, backgroundColor: "#cfeffb" }
    }
    return (
        <Grid item>
            <StyledTooltip title={title}>
                <div>
                    <IconButton disabled={disabled} onClick={onClick} style={iconStyle}>
                        <Icon style={{ color }} />
                    </IconButton>
                </div>    
            </StyledTooltip>
        </Grid>
    )
}

export default Icon;